import { render, staticRenderFns } from "./OrgsModal.vue?vue&type=template&id=f4f8e418&"
import script from "./OrgsModal.vue?vue&type=script&lang=js&"
export * from "./OrgsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports